import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    allExperiences: null,
    allExperienceGroups: null,
    currentExperience: null,
    currentExperienceGroup: null,
    currentExperienceGroupId: null,

  },
  getters: {
    getAllExperiences: (state) => {
      if (state.allExperiences) {
        return state.allExperiences;
      }
    },
    getAllExperienceGroups: (state) => {
      if (state.allExperienceGroups) {
        return state.allExperienceGroups;
      }
    },
    getExperienceByURL: (state, getters) => (url) => {
      if (state.allExperiences) {
        return state.allExperiences.find((l) => l.cmsRelativeUrl === url);
      }
    },
    getExperienceGroupByURL: (state, getters) => (url) => {
      if (state.allExperienceGroups) {
        return state.allExperienceGroups.find((l) => l.cmsRelativeUrl === url);
      }
    },
    getCurrentExperience: (state) => {
      if (state.currentExperience) {
        return state.currentExperience;
      }
    },
    getCurrentExperienceGroupId: (state) => {
      if (state.currentExperienceGroupId) {
        return state.currentExperienceGroupId;
      }
    },
    getCurrentExperienceGroup: (state) => {
      if (state.currentExperienceGroup) {
        return state.currentExperienceGroup;
      }
    },
  },
  mutations: {
    setAllExperiences(state, experiences) {
      state.allExperiences = experiences;
    },
    setAllExperienceGroups(state, experienceGroups) {
      state.allExperienceGroups = experienceGroups;
    },
    setCurrentExperience(state, experience) {
      state.currentExperience = experience;
    },
    setCurrentExperienceGroupId(state, id) {
      state.currentExperienceGroupId = id;
    },
    setCurrentExperienceGroup(state, experienceGroup) {
      state.currentExperienceGroup = experienceGroup;
    },
  },
  actions: {
    // fetchAllExperiences({
    //  commit, rootGetters,
    // }) {
    //   return new Promise((resolve) => {
    //     axios.get(`/core/experiences/live/lang/${rootGetters['pages/currentLang']}`)
    //       .then((res) => {
    //          resolve(res.data)
    //       })
    //       .catch((error) => console.log(error));
    //   })
    // },

    fetchAllNiis() {
      return new Promise((resolve) => {
        axios.get('/core/services/NII').then((res) => {
         resolve(res.data) 
        })
      })
    },

    fetchAllVillaServices() {
      return new Promise((resolve) => {
        axios.get('/core/services/Villa_Service').then((res) => {
         resolve(res.data) 
        })
      })
    },

    fetchAllExperienceServices() {
      return new Promise((resolve) => {
        axios.get('/core/services/Experience_Service').then((res) => {
         resolve(res.data) 
        })
      })
    },

    submitNii({}, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/salesoperations/bookings/noninvoiceditems`, data).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    
    submitService({}, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/salesoperations/bookings/servicebookings`, data).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    fetchExperienceById({
      commit, state, rootGetters,
    }, id) {
      return new Promise((resolve, reject) => {
        state.currentExperience = null;
        // experience not in allPressPages state so fetch and set from API
        // const odata = '$select=*';
        // maxNumOfPeople,pagename,agreedPrice,deposit,priceFrom,netPriceToSupplier
        // const odata = '$select=id,name,ExperienceGroupId,Image,SlideshowId,Summary,Title,BrowserTitle,H1,H2,BrowserTitle,MetaKeywords,MetaDescription,Content,CMSRelativeUrl,Experiences_ShowPricingPublic,Experiences_ShowPricingDates,Experiences_PricingDescription,Experiences_PricingReductionsAndAddonsText';
        // const odata = '$select=id,name,ExperienceGroupId,Image,SlideshowId,Summary,Title,BrowserTitle,H1,H2,BrowserTitle,MetaKeywords,MetaDescription,Content,CMSRelativeUrl,Experiences_ShowPricingPublic,Experiences_ShowPricingDates,Experiences_PricingDescription,CancellationPolicyNotes,Experiences_PricingReductionsAndAddonsText,tripDestination,maxNumOfPeople,pagename,agreedPrice,deposit,priceFrom,netPriceToSupplier';
        axios.get(`/core/experiences/live/${id}/lang/${rootGetters['pages/currentLang']}`)
          .then((res) => {
            commit('setCurrentExperience', res.data);
            resolve(res.data);
          });
      });
    },

    fetchExperiencePricingByIdAndYear({
      commit, dispatch, getters, rootGetters,
    }, data) {
      return new Promise((resolve, reject) => {
        axios.get(`/core/pricing/pricingtable/experience/${data.experienceId}/${data.year}`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => reject(error));
      });
    },

    fetchExperienceGroupContentById({
      commit, dispatch, getters, rootGetters,
    }, groupId) {
      return new Promise((resolve, reject) => {
        axios.get(`/core/experiences/live/groupcontent/${groupId}/lang/${rootGetters['pages/currentLang']}`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => reject(error));
      });
    },
    fetchExperienceGroupById({
      commit, dispatch, getters, rootGetters,
    }, groupId) {
      return new Promise((resolve, reject) => {
        axios.get(`/core/experiences/grouptier/${groupId}/lang/${rootGetters['pages/currentLang']}`)
          .then((res) => {
            commit('setCurrentExperienceGroup', res.data);
            resolve(res.data);
          })
          .catch((error) => reject(error));
      });
    },
    fetchExperiencesNearVilla({
      commit, dispatch, getters, rootGetters,
    }, villaid) {
      return new Promise((resolve, reject) => {
        // console.log('villaid', villaid);
        axios.get(`/core/experiences/near/villaid/${villaid}`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => reject(error));
      });
    },
    // update profile
    SendExpNearEnquiry({ commit, dispatch, getters }, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/experiences/near/bookingid/${data.bookingId}/sendenquiry`, data.basket).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },

  },

};
